import { jsx } from "react/jsx-runtime";
import { Suggest } from "@blueprintjs/select";
import { Keys } from "@blueprintjs/core";
import React, { useCallback, useMemo, useRef } from "react";
import classNames from "classnames";
import { itemListPredicate } from "../TgSelect";
const itemRenderer = (i = "", { index, handleClick, modifiers }) => /* @__PURE__ */ jsx(
  "div",
  {
    onClick: handleClick,
    className: classNames(
      "tg-select-option bp3-menu-item bp3-fill bp3-text-overflow-ellipsis",
      {
        "bp3-active": modifiers.active
      }
    ),
    children: i
  },
  index
);
const TgSuggest = ({
  autoFocus,
  disabled,
  inputProps: _inputProps,
  intent,
  isLoading,
  isSimpleSearch,
  multi,
  noResultsText,
  notCreateable,
  onBlur,
  onChange,
  optionRenderer,
  //pull this one out here so it doesn't get passsed along
  options,
  placeholder,
  popoverProps: _popoverProps,
  value,
  ...rest
}) => {
  const inputRef = useRef(null);
  const handleItemSelect = useCallback(
    (item) => {
      inputRef.current && inputRef.current.blur();
      return onChange?.(item);
    },
    [onChange]
  );
  const _itemListPredicate = useCallback(
    (queryString, item) => {
      return itemListPredicate(queryString, item, isSimpleSearch);
    },
    [isSimpleSearch]
  );
  const popoverProps = useMemo(
    () => ({
      minimal: true,
      className: classNames("tg-select", {
        "tg-single-select": !multi
      }),
      wrapperTagName: "div",
      usePortal: false,
      canEscapeKeyClose: true,
      ..._popoverProps
    }),
    [multi, _popoverProps]
  );
  const onKeyDown = useCallback((e) => {
    const { which } = e;
    if (which === Keys.ENTER) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (which === Keys.ESCAPE || which === Keys.TAB) {
      if (inputRef.current != null) {
        inputRef.current.blur();
      }
      e.preventDefault();
      e.stopPropagation();
    }
  }, []);
  const inputProps = useMemo(
    () => ({
      inputRef: (n) => {
        if (n) inputRef.current = n;
      },
      autoFocus,
      placeholder: placeholder || "Type here...",
      disabled,
      // tg: adding isLoading will cause the input to be blurred when using generic select asReactSelect (don't do it),
      intent,
      ..._inputProps
    }),
    [disabled, _inputProps, intent, placeholder, autoFocus]
  );
  return /* @__PURE__ */ jsx(
    Suggest,
    {
      closeOnSelect: true,
      items: options,
      query: value,
      popoverProps,
      onKeyDown,
      onItemSelect: handleItemSelect,
      noResults: null,
      resetOnSelect: false,
      onQueryChange: onChange,
      itemRenderer,
      itemListPredicate: _itemListPredicate,
      selectedItem: value,
      inputValueRenderer: (item) => item,
      inputProps,
      isSimpleSearch,
      onChange,
      ...rest
    }
  );
};
export default TgSuggest;
